import Chart from "chart.js";

export default function() {
  Chart.defaults.global.defaultFontFamily = "Noto Sans TC"; // 全局字體設置。

  Chart.defaults.global.elements.point.pointStyle = "rectRounded";
  Chart.defaults.global.elements.point.radius = 2.5; // 方圓點尺寸。

  Chart.defaults.global.elements.line.borderWidth = 1.7; // 折線粗細。
  Chart.defaults.global.elements.line.fill = false; // 背景色關閉。
  Chart.defaults.global.elements.line.tension = 0; // 設定曲線，直線為零。

  Chart.defaults.global.tooltips.mode = "index"; // 查找具有相同索引的項目。
  Chart.defaults.global.tooltips.titleFontSize = 13; // // 提示框大標題字級。
  Chart.defaults.global.tooltips.bodySpacing = 4; // 提示框小標題行距。
  Chart.defaults.global.tooltips.xPadding = 10; // 提示框內距。
  Chart.defaults.global.tooltips.yPadding = 10;
  // Chart.defaults.global.tooltips.intersect = true; // 鼠標與元素相交時工具提示模式，預設值。

  Chart.defaults.global.title.display = true; // 顯示標題。
  Chart.defaults.global.title.fontColor = "#343a40";
  Chart.defaults.global.title.fontSize = 17;
  // Chart.defaults.global.title.position = "top"; // 標題位置，預設值。

  // Y 軸最小預設值。Y 軸最大預設值，使用 suggestedMax 支援增長或縮短機制，符合非固定 range 要求。
  Chart.defaults.scale.ticks.suggestedMin = 0;
  Chart.defaults.scale.ticks.suggestedMax = 10;
}
